@if (legendItems$ | async; as items) {
  @if (items.length) {
    @for (item of items.slice().reverse(); track item) {
      <ng-container #renderedLegends>
        @if (getLegend) {
          <div>
            @if (item.title) {
              <mat-list-item>
                <mat-icon
                  id="legend-toggle"
                  class="igo-chevron"
                  matListItemIcon
                  igoCollapse
                  [target]="legend"
                  [collapsed]="item.collapsed"
                  (toggle)="toggleLegendItem($event, item)"
                  >expand_less
                </mat-icon>
                <span matListItemTitle
                  >{{ computeItemTitle(item) | async }}
                </span>
              </mat-list-item>
            }
            <div
              #legend
              class="igo-layer-legend"
              [ngClass]="{ 'with-title': item.title }"
            >
              @if (currentStyle !== undefined) {
                <mat-form-field subscriptSizing="dynamic">
                  <mat-select
                    tooltip-position="below"
                    matTooltipShowDelay="500"
                    [matTooltip]="
                      'igo.geo.layer.legend.selectStyle' | translate
                    "
                    [(ngModel)]="currentStyle"
                    (selectionChange)="onChangeStyle()"
                  >
                    @for (style of styles; track style) {
                      <mat-option [value]="style.name">{{
                        style.title
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (!item.collapsed) {
                <div>
                  @if (item.url) {
                    <div>
                      @if (item.imgGraphValue) {
                        <img
                          igoImageError
                          [hideError]="true"
                          #renderedLegend
                          id="{{ item.title }}"
                          (load)="onLoadImage(item.title)"
                          [src]="item.imgGraphValue"
                          alt="{{
                            'igo.geo.layer.legend.loadingLegendText' | translate
                          }}"
                        />
                      }
                      @if (imagesHeight[item.title] < 16) {
                        <small>
                          {{ 'igo.geo.layer.legend.noLegendScale' | translate }}
                        </small>
                      }
                    </div>
                  }
                  @if (item.html) {
                    <div
                      [ngStyle]="item.style"
                      [innerHTML]="item.html | sanitizeHtml"
                    ></div>
                  }
                </div>
              }
            </div>
          </div>
        } @else {
          <small>
            {{ 'igo.geo.layer.legend.noLegendText' | translate }}
          </small>
        }
      </ng-container>
    }
  } @else {
    <small>
      {{ 'igo.geo.layer.legend.noLegendText' | translate }}
    </small>
  }
}
